import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataBagService } from 'src/app/common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { DateService } from 'src/app/common/date.service';

@Component({
	selector: 'app-group-offer-price-setting-publication-dialog',
	templateUrl: './group-offer-price-setting-publication-dialog.component.html',
	styleUrls: ['./group-offer-price-setting-publication-dialog.component.scss'],
})
export class GroupOfferPriceSettingPublicationDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<GroupOfferPriceSettingPublicationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		protected bag: DataBagService,
		protected infobox: InfoboxService,
		protected dateService: DateService,
	) {}
	showTime = false;
	time;
	date;
	selectTime = 0;
	changeTime = [
		{ id: 0, name: 'Teraz' },
		{ id: 1, name: 'Określona data' },
	];

	generateTerms() {
		const terms = this.data[0]
			.map((item) => {
				if (item.termPrice == null) {
					return;
				}
				if (item.termPrice.status !== 'D') {
					return;
				}
				let dateToSend;
				// jeśli wybrana opcja określona data to konwertuj wybrany czas, jeśli nie bierz aktualną date
				if (this.selectTime == 1) {
					const splitTime = this.time.split(':');
					const minutes = parseInt(splitTime[0]) * 60 + parseInt(splitTime[1]);
					dateToSend = new Date(new Date(this.date).getTime() + minutes * 60000);
				} else {
					dateToSend = new Date();
				}

				const generateTerms = {
					id: null,
					term: item.id,
					price: item.termPrice.price,
					status: 'P',
					dateFrom: dateToSend,
				};
				this.publicTermPrice(generateTerms);
				return item;
			})
			.filter((value) => {
				return value !== undefined;
			});
		this.updateTerm(terms);
		this.dialogRef.close(true);
	}

	updateTerm(terms) {
		this.bag.put('/offer/term/bulk_update/', terms, (result, error) => {
			if (error) {
				return;
			}
			if (this.selectTime == 1) {
				this.infobox.success(
					`Terminy zostaną opublikowane:
						${this.dateService.datetimeWithTimezone(this.date).date}
						 o godzinie
						${this.time}`,
				);
				terms.forEach((term) => {
					const activeTerm = this.data[2].find((item) => item.id == term.id);

					term.termPrice = activeTerm.termPrice;
				});
			}
			terms.forEach((term) => {
				term.termPrice.status = 'P';
			});
		});
	}

	publicTermPrice(termPrice) {
		this.bag.post('/offer/term_price/', termPrice, (result, error) => {
			if (error) {
				this.infobox.error(JSON.stringify(error.error));
				return;
			}
		});
	}
}
